module.exports = __webpack_public_path__ + "img/concierge.9b0e151c.png";